import { UIHeading1, UIHeading2, UIHeading3, UIHeading4, UIHeading5, UIHeading6, UIText1, UIText2, UIText3 } from '../../../typography';
var SIZE_TO_HEADING_MAP = {
  XXL: UIHeading1,
  XL: UIHeading2,
  L: UIHeading3,
  M: UIHeading4,
  S: UIHeading5,
  XS: UIHeading6
};
var SIZE_TO_TEXT_MAP = {
  XXL: UIText1,
  XL: UIText1,
  L: UIText1,
  M: UIText1,
  S: UIText2,
  XS: UIText3
};
export var getTypographyComponent = function getTypographyComponent(fontSize, fontWeight) {
  return fontWeight === 'bold' ? SIZE_TO_HEADING_MAP[fontSize] : SIZE_TO_TEXT_MAP[fontSize];
};